export default __webpack_public_path__ + "static/media/asphalt-basketballcourt.34acb45a.jpg";